// Mock data for March Global website

export const companyInfo = {
  name: "March Global",
  tagline: "Your Global Trading Partner",
  founded: 2024,
  email: "sales@march-global.com",
  phone: "+971 4 570 3483",
  address: "Meydan, Dubai",
  description: "March Global is a dynamic trading company founded in 2024, specializing in premium food products and industrial packaging solutions. We pride ourselves on our strategic partnership with the renowned Olives factory in Gimlek, Bursa, and our global network for sourcing high-quality industrial packaging and adhesive materials."
};

export const foodProducts = [
  {
    id: 1,
    name: "Zeytino Green Olives",
    description: "Premium hand-picked green olives from our partner Zeytino factory in Gimlek, Bursa. Known for their exceptional taste and quality.",
    image: "https://customer-assets.emergentagent.com/job_food-industrial/artifacts/8viodl0t_Green%20Olives.jpg",
    category: "Zeytino Brand"
  },
  {
    id: 2,
    name: "Zeytino Black Olives",
    description: "Premium black olives from Zeytino, carefully selected and processed to maintain their natural flavor and nutritional value.",
    image: "https://customer-assets.emergentagent.com/job_food-industrial/artifacts/rxq95zu7_Black%20Olives.jpg",
    category: "Zeytino Brand"
  },
  {
    id: 3,
    name: "Zeytino Grilled Green Olives",
    description: "Specially grilled green olives from Zeytino, offering a unique smoky flavor and distinctive taste profile.",
    image: "https://customer-assets.emergentagent.com/job_food-industrial/artifacts/ik9cdb1z_Grilled%20Green%20Olives.jpg",
    category: "Zeytino Brand"
  },
  {
    id: 4,
    name: "Mixed Stuffed Olives",
    description: "A diverse selection of stuffed olive varieties with peppers, cheese, and almonds, perfect for retail and food service industries.",
    image: "https://customer-assets.emergentagent.com/job_food-industrial/artifacts/2dgvd1fx_Screenshot_20260402_232734_WhatsApp.jpg",
    category: "Olives"
  }
];

export const industrialProducts = [
  {
    id: 7,
    name: "Industrial Shrink Wrap",
    description: "High-quality shrink wrap films for secure packaging and protection of various products during storage and transportation.",
    image: "https://customer-assets.emergentagent.com/job_food-industrial/artifacts/qbq6g90o_P.O.F-shrink_film.jpg",
    category: "Packaging Films"
  },
  {
    id: 8,
    name: "Protection Films for Aluminum Profiles",
    description: "Specialized protective films designed to safeguard aluminum profiles and surfaces from scratches and damage during manufacturing, processing, and shipping.",
    image: "https://customer-assets.emergentagent.com/job_food-industrial/artifacts/e3cpyuki_ALuminum%20SPV.jpg",
    category: "Protection Films"
  },
  {
    id: 9,
    name: "Glass Protection Films",
    description: "Premium protective films for glass surfaces, ensuring safe handling and transport while maintaining clarity and preventing scratches.",
    image: "https://customer-assets.emergentagent.com/job_food-industrial/artifacts/trtdfmqe_Glass%20protection%20film.jpg",
    category: "Protection Films"
  },
  {
    id: 10,
    name: "Stainless Steel Laser Films",
    description: "High-performance protective films specifically designed for stainless steel surfaces during laser cutting and processing applications.",
    image: "https://customer-assets.emergentagent.com/job_food-industrial/artifacts/5kh22np1_SS%20Protection%20film.jpeg",
    category: "Protection Films"
  },
  {
    id: 11,
    name: "Double-Sided Adhesive Tapes",
    description: "Industrial-grade double-sided tapes with strong bonding for various applications in manufacturing and assembly.",
    image: "https://customer-assets.emergentagent.com/job_food-industrial/artifacts/xv6bc95s_DCT%201.jpg",
    category: "Adhesive Solutions"
  },
  {
    id: 12,
    name: "Specialty Packaging Materials",
    description: "Comprehensive range of packaging materials including tapes, wraps, and protective solutions for industrial use.",
    image: "https://customer-assets.emergentagent.com/job_food-industrial/artifacts/qkv8njxw_Packaging.png",
    category: "Packaging Materials"
  },
  {
    id: 13,
    name: "Professional Adhesive Tapes",
    description: "High-performance adhesive tapes suitable for various industrial and commercial applications.",
    image: "https://customer-assets.emergentagent.com/job_food-industrial/artifacts/2n30j4zx_Tapes.png",
    category: "Adhesive Solutions"
  }
];

export const features = [
  {
    title: "Global Sourcing",
    description: "Access to premium products from trusted suppliers worldwide"
  },
  {
    title: "Quality Assurance",
    description: "Strict quality control ensures only the best products reach you"
  },
  {
    title: "Reliable Partnership",
    description: "Long-term relationships with manufacturers for consistent supply"
  },
  {
    title: "Competitive Pricing",
    description: "Direct sourcing enables us to offer competitive market prices"
  }
];
